export enum AUTHORS_SELECT_VALUE_KEYS {
  ID = 'id',
  NAME = 'name'
}
